import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";

class AdminLogin extends Component {
  constructor() {
    super();
    this.state = {
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  render() {
    const styles1 = {
      width: "200px",
    };
    const { creatifa } = this.state;
    return (
      <div>
        <div className="container-fluid overflow-hidden">
          <div className="container mt-6 mb-5 py-3">
            <h2 className="fw-bold text-center my-4">
              Creatifa Admin Login Panel
            </h2>
            <form>
              <div className="mb-3">
                <label className="form-label">Username</label>
                <input
                  name="username"
                  type="username"
                  className="form-control"
                  id="exampleInputUsername1"
                  aria-describedby="usernameHelp"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  name="password"
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                />
              </div>
              <button type="submit" className="btn btn-red">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminLogin;
